import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { getApi } from "../../services/api/globalApi";
import Pagination from "./../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import Loadning from "./../../components/common/loading/Loading.jsx";
import { FaUsers } from "react-icons/fa";
import LoanFilter from "./LoanFilter.jsx";
import ChangeStatusModal from "../../components/loan/loan-modal/ChangeStatusModal.jsx";
import { context } from "../../context/context.js";

const LoanList = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const { utils } = useContext(context);

  const getLoan = async (params) => {
    setData([]);
    setShowLoading(true);
    const path = "admin/loans";
    try {
      const response = await getApi({ path, params: { ...params, limit: 20 } });
      console.log(response?.data);
      setPagination(response?.data);
      setData(response?.data.docs);
      setShowLoading(false);
    } catch (error) {
      console.log(error);
      setShowLoading(false);
    }
  };

  useEffect(() => {
    getLoan({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getLoan(allFilter);
  };

  const navigate = useNavigate();

  const editLoan = (item) => {
    navigate(`/loan/${item._id}`, { state: item });
  };

  const loanRef = useRef();
  const [loanData, setLoanData] = useState();

  const changeStatus = (item) => {
    setLoanData(item);
    loanRef.current.showModal();
  };

  return (
    <Fragment>
      {/* {showLoading && <Loadning />} */}
      <ChangeStatusModal ref={loanRef} data={loanData} reGetData={getLoan} />
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
          <FaUsers size={26} />
          لیست وام ها
        </h6>

        <LoanFilter filterDataHandler={filterDataHandler} />

        {data?.length > 0 ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    نام
                  </th>
                  <th scope="col" className="px-6 py-3">
                    شماره
                  </th>
                  <th scope="col" className="px-6 py-3">
                    وضعیت
                  </th>
                  <th scope="col" className="px-6 py-3">
                    <span className="sr-only">ویرایش</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data
                  ? data?.map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                        >
                          <th
                            scope="row"
                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                          >
                            {item?.status == "pending" ? (
                              <span className="text-blue-600">
                                {item?.user?.name || "-"}
                              </span>
                            ) : (
                              <span>{item?.user?.name || "-"}</span>
                            )}
                          </th>
                          <td className="px-6 py-4">{item?.mobile || "-"}</td>
                          <td className="px-6 py-4">
                            {utils?.LOAN_STATUS?.[item?.status]?.name}
                          </td>
                          <td className="px-6 py-4 text-right flex">
                            <p
                              onClick={() => editLoan(item)}
                              className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                            >
                              نمایش
                            </p>
                            <p
                              onClick={() => changeStatus(item)}
                              className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                            >
                              تغییر وضعیت
                            </p>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="w-full py-6 flex justify-center items-center text-gray-800 dark:text-white">
            هیچ وام ثبت شده ای وجود ندارد.
          </p>
        )}
        <div className="mt-6">
          <Pagination
            pagination={pagination}
            filterDataHandler={filterDataHandler}
          />
        </div>
      </motion.div>
    </Fragment>
  );
};

export default LoanList;
